export enum ViewModalEnum{
    View = 1,
    Create = 2,
    Edit = 3
}